module.exports = __webpack_public_path__ + "img/GNHandLogo256.7b8ef470.png";